module.exports = __webpack_public_path__ + "static/media/3d_scan_gold_hand_pendant_result.2da95d3d.jpg";